"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SEATS_INPUT_EL = exports.FREQUENCY_RADIO_LABEL_ELS = exports.MONTHLY_RADIO_LABEL_EL = exports.ANNUAL_RADIO_LABEL_EL = exports.MONTHLY_RADIO_EL = exports.ANNUAL_RADIO_EL = exports.EDITION_HEADER_EL_MAP = void 0;
const getWidgetQs_1 = require("../../utils/getWidgetQs");
const { qsOrThrowFit } = (0, getWidgetQs_1.getWidgetQs)(".pricing_calc_widget");
const qsEditionHeader = (selector) => {
    const headerEl = qsOrThrowFit(selector);
    return {
        priceEl: qsOrThrowFit(".editionprice", headerEl),
        subTextEl: qsOrThrowFit(".perusertext", headerEl),
        unavailableEl: qsOrThrowFit(".editionunavailable", headerEl),
    };
};
exports.EDITION_HEADER_EL_MAP = {
    Lite: qsEditionHeader("#lite_table_header"),
    Starter: qsEditionHeader("#starter_table_header"),
    Business: qsEditionHeader("#business_table_header"),
    Enterprise: qsEditionHeader("#enterprise_table_header"),
};
exports.ANNUAL_RADIO_EL = qsOrThrowFit("#annual_radio");
exports.MONTHLY_RADIO_EL = qsOrThrowFit("#monthly_radio");
exports.ANNUAL_RADIO_LABEL_EL = qsOrThrowFit("#annual_radio_label");
exports.MONTHLY_RADIO_LABEL_EL = qsOrThrowFit("#monthly_radio_label");
exports.FREQUENCY_RADIO_LABEL_ELS = [
    exports.ANNUAL_RADIO_LABEL_EL,
    exports.MONTHLY_RADIO_LABEL_EL,
];
exports.SEATS_INPUT_EL = qsOrThrowFit("#seats_input");
